/**
 * IMPORTS
 */
import compressImage from 'browser-image-compression';
import {t} from 'i18next';
import * as Loadis from 'loadis';
import findLastIndex from 'lodash/findLastIndex';
import {delegates} from 'packetis';
import accountSelectors from 'src/aggregates/accounts/selectors';
import {getAgentName} from 'src/aggregates/agents/selectors';
import {remove as removeAPI} from 'src/aggregates/conversations/api';
import {sendMessage as sendMessageAPI} from 'src/aggregates/conversations/api';
import {FileUploadError}
    from 'src/aggregates/conversations/err/fileuploaderror';
import {ANALYZE_CONVERSATIONS} from 'src/aggregates/conversations/mutations';
import {CREATE_CONVERSATION} from 'src/aggregates/conversations/mutations';
import {FINISH_CONVERSATION} from 'src/aggregates/conversations/mutations';
import {FORCE_FINISH} from 'src/aggregates/conversations/mutations';
import {FREE_CONVERSATION} from 'src/aggregates/conversations/mutations';
import {RETRY_MESSAGE} from 'src/aggregates/conversations/mutations';
import {SEND_MESSAGE} from 'src/aggregates/conversations/mutations';
import {SEND_PAUSED} from 'src/aggregates/conversations/mutations';
import {SEND_TEMPLATE} from 'src/aggregates/conversations/mutations';
import {TRANSFER_CONVERSATION} from 'src/aggregates/conversations/mutations';
import {FETCH_AGENT_CONVERSATIONS} from 'src/aggregates/conversations/queries';
import {FETCH_AGENTS} from 'src/aggregates/conversations/queries';
import {FETCH_AGENTS_MESSAGES_METRICS}
    from 'src/aggregates/conversations/queries';
import {FETCH_CONTACTS_ONGOING} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATION} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATION_APP} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATION_DATA} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATION_FLOW} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATIONS_BY_IDS} from 'src/aggregates/conversations/queries';
import {FETCH_CONVERSATIONS_REPORT}
    from 'src/aggregates/conversations/queries';
import {FETCH_MESSAGE_BY_ORIGINAL_ID}
    from 'src/aggregates/conversations/queries';
import {FETCH_ONGOING_CONVERSATIONS}
    from 'src/aggregates/conversations/queries';
import {FETCH_PAGE} from 'src/aggregates/conversations/queries';
import {FETCH_QUALITY_REPORT} from 'src/aggregates/conversations/queries';
import {FETCH_REALTIME_METRICS} from 'src/aggregates/conversations/queries';
import {NEED_TEMPLATE} from 'src/aggregates/conversations/queries';
import conversationSelectors from 'src/aggregates/conversations/selectors';
import {IAgentsMetricsById} from 'src/aggregates/conversations/state.d';
import {IMetricsByPeriod} from 'src/aggregates/conversations/state.d';
import {IRealTimeMetrics} from 'src/aggregates/conversations/state.d';
import {IUploadOnProgress} from 'src/aggregates/conversations/state.d';
import {IUploadOnSuccess} from 'src/aggregates/conversations/state.d';
import customers from 'src/aggregates/customers/selectors';
import * as customersUtils from 'src/aggregates/customers/utils';
import {fetch as fetchPreferences} from 'src/aggregates/preferences/selectors';
import {fetch as getUser} from 'src/aggregates/user/selectors';
import {getServerUrl} from 'src/aggregates/user/selectors';
import {packetis} from 'src/aggregates/user/xmpp/main';
import {reducePayload} from 'src/aggregates/utils/payloads';
import timeout from 'src/aggregates/utils/timeout';
import {logger} from 'src/logger';
import graphis from 'src/services/graphis';


/**
 * TYPES
 */
import {ICreateConversationResponse}
    from 'src/aggregates/conversations/mutations.d';
import {IFinishConversationResponse}
    from 'src/aggregates/conversations/mutations.d';
import {IFinishConversationVariables}
    from 'src/aggregates/conversations/mutations.d';
import {IForceFinishResponse} from 'src/aggregates/conversations/mutations.d';
import {IFreeConversationResponse}
    from 'src/aggregates/conversations/mutations.d';
import {ISendMessageResponse}
    from 'src/aggregates/conversations/mutations.d';
import {ISendTemplateResponse}
    from 'src/aggregates/conversations/mutations.d';
import {ITransferConversationResponse}
    from 'src/aggregates/conversations/mutations.d';
import {ITransferConversationVariables}
    from 'src/aggregates/conversations/mutations.d';
import {IAgentSession} from 'src/aggregates/conversations/queries.d';
import {IConversationApp} from 'src/aggregates/conversations/queries.d';
import {IConversationFlow} from 'src/aggregates/conversations/queries.d';
import {IConversationFlowResult} from 'src/aggregates/conversations/queries.d';
import {IConversationLoaded} from 'src/aggregates/conversations/queries.d';
import {IConversationMessages} from 'src/aggregates/conversations/queries.d';
import {IConversationsByIds} from 'src/aggregates/conversations/queries.d';
import {IConversationsReport} from 'src/aggregates/conversations/queries.d';
import {IConversationsReportMetric}
    from 'src/aggregates/conversations/queries.d';
import {IFetchAgentConversationsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchAgentsMessagesMetrics}
    from 'src/aggregates/conversations/queries.d';
import {IFetchAgentsMessagesMetricsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchAgentsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchContactsOngoingConversationsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationAppResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationFlowResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationMessagesResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationsByIdsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchConversationsReportResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchMessageByOriginalIdResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchOngoingConversationsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchPageResponse} from 'src/aggregates/conversations/queries.d';
import {IFetchPageVariables} from 'src/aggregates/conversations/queries.d';
import {IFetchQualityConversationsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IFetchRealTimeMetricsResponse}
    from 'src/aggregates/conversations/queries.d';
import {IMessageByOriginalIdResult}
    from 'src/aggregates/conversations/queries.d';
import {INeedTemplateResponse} from 'src/aggregates/conversations/queries.d';
import {IOngoingConversation} from 'src/aggregates/conversations/queries.d';
import {IPage} from 'src/aggregates/conversations/queries.d';
import {IAnalyzeConversations}
    from 'src/aggregates/conversations/mutations.d';
import {IAnalyzeConversationsResponse}
    from 'src/aggregates/conversations/mutations.d';
import {IAnalyzeConversationsVariables}
    from 'src/aggregates/conversations/mutations.d';
import {IQualityReport} from 'src/aggregates/conversations/queries.d';
import {IQualityReportRows} from 'src/aggregates/conversations/queries.d';
import {IAnalyzeConversationsResult}
    from 'src/aggregates/conversations/utils.d';
import {IQualityReportResult} from 'src/aggregates/conversations/utils.d';
import {ITemplateInput} from 'src/aggregates/conversations/queries.d';
import {IAttachment} from 'src/aggregates/conversations/state.d';
import {IConversation} from 'src/aggregates/conversations/state.d';
import {IMessage} from 'src/aggregates/conversations/state.d';
import {IRealTimeMetrics as IRealTimeMetricsResponse}
    from 'src/aggregates/conversations/queries.d';
import {Statuses} from 'src/aggregates/user/state.d';
import {IAgentsByAccount} from 'src/aggregates/conversations/utils.d';
import {IAgentsByAccountAndQueue} from 'src/aggregates/conversations/utils.d';
import {IAgentsByQueue} from 'src/aggregates/conversations/utils.d';
import {IContactsByAccount} from 'src/aggregates/conversations/utils.d';
import {IContactsByQueue} from 'src/aggregates/conversations/utils.d';
import {IContactsByAccountAndQueue} from 'src/aggregates/conversations/utils.d';
import {IConversationMetrics} from 'src/aggregates/conversations/utils.d';
import {IConversationBasicMetrics} from 'src/aggregates/conversations/utils.d';
import {IBaseConversation} from 'src/aggregates/conversations/utils.d';
import {IConversationsMetrics} from 'src/aggregates/conversations/utils.d';
import {IConversationsMetricsByAgent}
    from 'src/aggregates/conversations/utils.d';
import {ICreateResult} from 'src/aggregates/conversations/utils.d';
import {IFinishResult} from 'src/aggregates/conversations/utils.d';
import {IHistoryOngoing} from 'src/aggregates/conversations/utils.d';
import {IMessagesMetricsByAgent} from 'src/aggregates/conversations/utils.d';
import {IRetryMessageResult} from 'src/aggregates/conversations/utils.d';
import {ISendMessageResult} from 'src/aggregates/conversations/utils.d';
import {ISendTemplateResult} from 'src/aggregates/conversations/utils.d';
import {ITimesMetrics} from 'src/aggregates/conversations/utils.d';
import {ITotalTime} from 'src/aggregates/conversations/utils.d';
import {ITransferResult} from 'src/aggregates/conversations/utils.d';
import {IGraphisError} from 'src/aggregates/index.d';
import {fetch as fetchUser} from 'src/aggregates/user/selectors';
import {IMessage as ITimelineMessage} from 'src/aggregates/timelines/state.d';
import uuid4 from 'uuid4';
import getPeriods from 'src/utils/getPeriods';


/**
 * CONSTANTS AND DEFINITIONS
 */
const COMPRESSIBLE_IMAGES = ['image/png', 'image/jpg', 'image/jpeg'];
const REASON_UNKNOWN = 'unknown';
const SECOND = 1000;
const TIMEOUT = 30 * SECOND;
const notifications: Map<string, string> = new Map();
notifications.set('email', t('Novo e-mail'));
notifications.set('image', t('📷  Imagem'));
notifications.set('unsupported', t('🚫  Mensagem não suportada'));
notifications.set('audio', t('🎙️  Mensagem de voz'));
notifications.set('file', t('📄  Documento'));
notifications.set('video', t('🎥  Video'));
notifications.set('location', t('📍 Localização'));
notifications.set('vcard', t('👤 Contato'));
notifications.set('conversation', t('💬  Nova conversa'));
notifications.set('call', t('📞 Chamada perdida'));
notifications.set('interactiveList', t('🗒️ Mensagem interativa'));
notifications.set('interactiveOption', t('✅ Resposta da mensagem'));
const messageTypesIdToName: Map<number, string> = new Map();
messageTypesIdToName.set(0, 'text');
messageTypesIdToName.set(1, 'image');
messageTypesIdToName.set(2, 'audio');
messageTypesIdToName.set(3, 'file');
messageTypesIdToName.set(4, 'video');
messageTypesIdToName.set(5, 'link');
messageTypesIdToName.set(6, 'vcard');
messageTypesIdToName.set(7, 'location');
messageTypesIdToName.set(8, 'email');
messageTypesIdToName.set(10, 'interactiveList');
messageTypesIdToName.set(11, 'interactiveOption');
messageTypesIdToName.set(12, 'template');
messageTypesIdToName.set(17, 'call');
messageTypesIdToName.set(-1, 'unsupported');
const messageTypesNameToId: Map<string, number> = new Map();
messageTypesNameToId.set('text', 0);
messageTypesNameToId.set('image', 1);
messageTypesNameToId.set('audio', 2);
messageTypesNameToId.set('file', 3);
messageTypesNameToId.set('video', 4);
messageTypesNameToId.set('link', 5);
messageTypesNameToId.set('vcard', 6);
messageTypesNameToId.set('location', 7);
messageTypesNameToId.set('email', 8);
messageTypesNameToId.set('interactiveList', 10);
messageTypesNameToId.set('interactiveOption', 11);
messageTypesNameToId.set('template', 12);
messageTypesNameToId.set('call', 17);
messageTypesNameToId.set('unsupported', -1);

// set 'no-message' app agent status
const NO_MESSAGE = 3;

// set a key-value structure to control whether the auto message has
// already been sent to the conversation
const AUTO_MESSAGE_SENT_BY_CONVERSATION: Record<number, boolean> = {};


/**
 * CODE
 */

/**
 * I compress the file according to type
 *
 * :param file: file to compress
 *
 * :returns: compressed file or original file
 */
async function compressFile (file: File): Promise<File>
{
    // can compress image: compress it and return
    if (COMPRESSIBLE_IMAGES.includes(file.type) === true)
    {
        // try compress the image
        try
        {
            return await compressImage(file, {maxWidthOrHeight: 1080});
        }

        // failed to compress: log error and return original file
        catch (error)
        {
            // get current user id
            const user = fetchUser().id;

            // log error adn return file
            logger.error('CVJPZ0038E', {reason: error, user});
            return file;
        }
    }

    // cannot compress file: return original file
    return file;
}


/**
 * I create a conversation on conversis.
 *
 * :param account: conversation account
 * :param company: contact company
 * :param contactName: contact name
 * :param remote: conversation remote
 * :param subject: conversation subject
 * :param uid: agent uid
 *
 * :returns: promise with nothing
 */
async function create (
    account: number,
    company: number,
    contactName: string,
    remote: string,
    subject: string | null,
    uid: string,
): Promise<ICreateResult>
{
    // initialize response
    let response: ICreateConversationResponse;

    // request conversation creation
    try
    {
        response = await timeout(
            graphis.mutate(CREATE_CONVERSATION, {
                account,
                agent: uid,
                company,
                contact: remote,
                contactName,
                subject,
            }),
            TIMEOUT,
        );
    }

    // creation failed: log and abort with unknown reason
    catch (error)
    {
        logger.error('CVJPZ0042E', {
            account,
            contact: uid,
            reason: error,
            user: fetchUser().id,
        });
        return {
            data: null,
            dynamic: null,
            id: null,
            lastInteraction: null,
            reason: REASON_UNKNOWN,
            start: null,
            templateRequired: false,
        };
    }

    // get response data
    const {createConversation} = response.data;

    // failed to create conversation: return error
    if (createConversation.__typename === 'Error')
    {
        return {
            data: createConversation.info,
            dynamic: null,
            id: null,
            lastInteraction: null,
            reason: createConversation.code,
            start: null,
            templateRequired: false,
        };
    }

    // creation succeeded: return conversation information
    return {
        data: null,
        dynamic: createConversation.dynamic,
        id: createConversation.id,
        lastInteraction: createConversation.lastInteraction,
        reason: null,
        start: createConversation.start,
        templateRequired: createConversation.templateRequired,
    };
}


/**
 * I create a notification message body based on message type.
 *
 * :param body: message body
 * :param type: message type
 *
 * :returns: notification message body
 */
function createNotificationBody(body: string, type: string): string
{
    // get time representation
    const time = new Date();
    const timestamp = ` - ${time.toLocaleString(undefined, {
        hour: 'numeric',
        hour12: true,
        minute: 'numeric',
    })}`;


    // message type requires formatting: return formatted notification
    if (notifications.has(type))
    {
        return notifications.get(type) + timestamp;
    }

    // format is raw text: return message body
    if (type === 'text')
    {
        return body + timestamp;
    }

    // format is unsupported: return unsupported format notification
    return notifications.get('unsupported') + timestamp;
}


/**
 * I fetch conversation data.
 *
 * :param company: company id
 * :param conversation: conversation id
 *
 * :returns: promise with conversation or null
 */
async function fetch (
    company: number,
    conversation: number,
): Promise<IConversationLoaded | null>
{
    // initialize response
    let response: IFetchConversationResponse;

    // fetch conversation
    try
    {
        response = await graphis.query(FETCH_CONVERSATION_DATA,
                                       {company, id: conversation});
    }

    // fetch failed: return null
    catch (e)
    {
        return null;
    }

    // fetch finish: return conversation or null
    return response?.data?.conversation ?? null;
}


/**
 * I fetch conversation data.
 *
 * :param agents: agents uids
 * :param from: start date
 * :param to: end date
 * :param type: messages type
 * :param conversations: list of conversation ids
 *
 * :returns: promise with conversation or null
 */
async function fetchAgentsMessagesMetrics (
    agents: string[],
    from: number,
    to: number,
    type: number,
    conversations: number[],
): Promise<IMessagesMetricsByAgent | null>
{
    // initialize response
    let response: IFetchAgentsMessagesMetricsResponse;

    // get user info
    const {company, id: user, name} = fetchUser();

    // fetch conversation
    try
    {
        response = await graphis.query(
            FETCH_AGENTS_MESSAGES_METRICS,
            {
                agents,
                conversations,
                from,
                to,
                type,
            },
        );
    }

    // fetch failed: log and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: error.message,
                report: 'agents',
                user,
            },
        );
        return null;
    }

    // get error
    const graphisError = (response.data.result as IGraphisError);

    // failed: log and return null
    if (graphisError === null ||
        graphisError === undefined ||
        graphisError?.__typename === 'Error')
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: `${graphisError?.code}: ${graphisError?.info}`,
                report: 'agents',
                user,
            },
        );
        return null;
    }

    // get result
    const graphisResult = (response.data.result as IFetchAgentsMessagesMetrics);

    // metrics are not an array: return empty metrics
    if (Array.isArray(graphisResult.messagesMetrics) === false)
    {
        return {};
    }

    // set messages metrics by agent
    const metrics = graphisResult.messagesMetrics.reduce((result, metric) => ({
        ...result,
        [metric.uid]: metric.messages,
    }), {});

    // return metrics
    return metrics;
}


/**
 * I fetch conversations by ids.
 *
 * :param accounts: list of account ids
 * :param conversations: list of conversation ids
 *
 * :returns: promise with conversations or null
 */
async function fetchByIds (
    accounts: number[],
    conversations: number[],
): Promise<IConversationsReportMetric[] | null>
{
    // initialize response
    let response = {} as IFetchConversationsByIdsResponse;

    // build log infos
    const {company, id: user, name} = fetchUser();
    const ids = conversations.join(', ');

    // fetch conversations by ids
    try
    {
        response = await graphis.query(
            FETCH_CONVERSATIONS_BY_IDS,
            {accounts, conversations},
        );
    }

    // fetch failed: log and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0077E',
            {
                amount: ids.length,
                company,
                name,
                reason: error.message,
                user,
            },
        );
        return null;
    }

    // get error
    const graphisError = (response.data.result as IGraphisError);

    // failed: log and return null
    if (graphisError === null ||
        graphisError === undefined ||
        graphisError?.__typename === 'Error')
    {
        logger.error(
            'CVJPZ0077E',
            {
                amount: ids.length,
                company,
                name,
                reason: `${graphisError?.code}: ${graphisError?.info}`,
                user,
            },
        );
        return null;
    }

    // return converstasions
    return (response.data.result as IConversationsByIds).conversations;
}


/**
 * I fetch ongoing conversations of contacts.
 *
 * :param contacts: list of contacts uids
 *
 * :returns: promise with conversations or null
 */
async function fetchContactsOngoing(
    contacts: string[],
): Promise<IOngoingConversation[] | null>
{
    // initialize response
    let response: IFetchContactsOngoingConversationsResponse;

    // try fetch conversations
    try
    {
        // get query response
        response = await graphis.query(FETCH_CONTACTS_ONGOING, {contacts});

        // request fail: return null
        if (response.data.conversations === null ||
            response.data.conversations === undefined)
        {
            return null;
        }

        // return conversations
        return response.data.conversations;
    }

    // fetch failed: return null
    catch (e)
    {
        return null;
    }
}


/**
 * I fetch the conversation flow.
 *
 * :param conversation: conversation id
 * :param size: number of executions to be returned
 * :param offset: data offset
 *
 * :returns: promise with flow or null
 */
async function fetchConversationFlow(
    conversation: number,
    size: number,
    offset: number,
): Promise<IConversationFlow[] | null>
{
    // initialize response
    let response: IFetchConversationFlowResponse;

    // get user info
    const {company, id: user, name} = fetchUser();

    // fetch conversation flow
    try
    {
        // get query response
        response = await graphis.query(FETCH_CONVERSATION_FLOW, {
            conversation,
            offset,
            size,
        });
    }

    // fetch failed: log and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0072E',
            {
                company,
                name,
                reason: error.message,
                user,
            },
        );
        return null;
    }

    // get error
    const graphisError = (response.data.result as IGraphisError);

    // failed: log and return null
    if (graphisError === null ||
        graphisError === undefined ||
        graphisError?.__typename === 'Error')
    {
        logger.error(
            'CVJPZ0072E',
            {
                company,
                name,
                reason: `${graphisError?.code}: ${graphisError?.info}`,
                user,
            },
        );
        return null;
    }

    // return flow
    return (response.data.result as IConversationFlowResult).flow;
}


/**
 * I fetch a message by original id.
 *
 * :param originalId: message original id
 *
 * :returns: promise with message data or null
 */
async function fetchMessageByOriginalId (
    originalId: string,
): Promise<ITimelineMessage | null>
{
    // initialize response
    let response: IFetchMessageByOriginalIdResponse;

    // fetch message data
    try
    {
        response = await graphis.query(FETCH_MESSAGE_BY_ORIGINAL_ID,
                                       {originalId});
    }

    // fetch failed: return null
    catch (e)
    {
        return null;
    }

    // get fetch result
    const result = response.data?.messageByOriginalId;

    // set if request fail
    const fail = result === null || result === undefined ||
                 result?.__typename === 'Error';

    // request was successful: return reduced data
    if (fail !== true)
    {
        return await reducePayload(
            (result as IMessageByOriginalIdResult).message,
        );
    }

    // fetch failed and is a gupshup original id: refetch with alternative id
    if (originalId.startsWith('g') === true)
    {
        return fetchMessageByOriginalId('A' + originalId.substring(1));
    }

    // both requests failed: return null
    return null;
}


/**
 * I fetch a conversation.
 *
 * :param company: company id
 * :param id: conversation id
 *
 * :returns: promise with conversation
 */
async function fetchMessages (
    company: number,
    id: number,
): Promise<IConversationMessages | null>
{
    // initialize result
    let result: IFetchConversationMessagesResponse;

    // fetch conversation
    try
    {
        result = await graphis.query(FETCH_CONVERSATION, {company, id});
    }

    // fetch failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // fetch succeeded: return conversation
    return result.data.conversation;
}


/**
 * I fetch a conversation app.
 *
 * :param company: company id
 * :param id: conversation id
 *
 * :returns: promise with conversation
 */
async function fetchApp (company: number,
                         id: number): Promise<IConversationApp | null>
{
    // initialize result
    let result: IFetchConversationAppResponse;

    // fetch conversation
    try
    {
        result = await graphis.query(FETCH_CONVERSATION_APP, {company, id});
    }

    // fetch failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // fetch succeeded: return conversation
    return result.data.conversation;
}


/**
 * I fetch conversations report.
 *
 * :param from: start date
 * :param to: end date
 * :param accounts: list of account ids
 *
 * :returns: promise with report data or null
 */
async function fetchConversationsReport (
    from: number,
    to: number,
    accounts: number[],
): Promise<IConversationsReportMetric[] | null>
{
    // initialize response
    let response = {} as IFetchConversationsReportResponse;

    // get user info
    const {company, id: user, name} = fetchUser();

    // fetch conversations report
    try
    {
        response = await graphis.query(
            FETCH_CONVERSATIONS_REPORT,
            {accounts, from, to},
        );
    }

    // fetch failed: log and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: error.message,
                report: 'conversations',
                user,
            },
        );
        return null;
    }

    // get error
    const graphisError = (response.data.result as IGraphisError);

    // failed: log and return null
    if (graphisError === null ||
        graphisError === undefined ||
        graphisError?.__typename === 'Error')
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: `${graphisError?.code}: ${graphisError?.info}`,
                report: 'conversations',
                user,
            },
        );
        return null;
    }

    // return metrics
    return (response.data.result as IConversationsReport).metrics;
}


/**
 * I download the contents of an email message.
 *
 * :param message: message
 *
 * :returns: promise with message
 */
async function fetchEmail (
    message: ITimelineMessage,
): Promise<ITimelineMessage | null>
{
    // get email id
    const id = message.body;

    // get server url
    const severUrl = getServerUrl();

    // get download observable
    const observable = Loadis.download(`${severUrl}/emails/files/${id}`);

    // instantiate download observer
    const observer = new Loadis.DownloadObserver();

    // subscribe observer to observable
    observable.subscribe(...observer.observe());

    // initialize email
    let email = {};

    // download email contents
    try
    {
        // get email contents
        const result = await observer.wait();
        const data = await result.text();

        // parse email
        email = JSON.parse(data);
    }

    // operation failed: return null
    catch (e)
    {
        return null;
    }

    // return message updated with body and attachments
    return {
        ...message,
        attachments: email['attachments'],
        body: email['body'],
    };
}


/**
 * I fetch a conversation's page
 *
 * :param company: logged agent company
 * :param page: page number
 * :param session: logged agent session token
 * :param size: page size
 *
 * :returns: finished conversation or null
 */
async function fetchPage (
    company: number,
    page: number,
    session: string,
    size: number,
): Promise<IPage[] | null>
{
    // initialize result
    let result: IFetchPageResponse;

    // set query variables
    const variables: IFetchPageVariables = {company, page, session, size};

    // get page
    try
    {
        result = await graphis.query(FETCH_PAGE, variables);
    }

    // get page failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // finish succeeded: return conversation page
    return result.data.conversationsPage;
}


/**
 * I finish a conversation
 *
 * :param agent: agent uid
 * :param company: company id
 * :param conversation: conversation id
 * :param session: user session token
 *
 * :returns: finished conversation or null
 */
async function finish (
    agent: string,
    company: number,
    conversation: number,
    session: string,
): Promise<IFinishResult>
{
    // initialize response
    let response: IFinishConversationResponse;

    // set mutation variables
    const variables: IFinishConversationVariables = {
        agent,
        company,
        id: conversation,
        session,
    };

    // finish conversation
    try
    {
        response = await graphis.mutate(FINISH_CONVERSATION, variables);
    }

    // finish failed: log error and return id null and error reason unknown
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return {conversation, error: REASON_UNKNOWN};
    }

    // failed to finish conversation: get response data
    const {exitConversation} = response.data;

    // return id null and error reason
    if (exitConversation.__typename === 'Error')
    {
        return {conversation, error: exitConversation.code};
    }

    // finish succeeded: return conversation id and reason null
    return {conversation: exitConversation.id, error: null};
}


/**
 * I force finish a conversation.
 *
 * :param conversation: conversation id
 *
 * :returns: finished conversation id or null
 */
async function forceFinish (conversation: number): Promise<number | null>
{
    // initialize mutation result
    let result: IForceFinishResponse;

    // try finish conversation
    try
    {
        // finish conversation
        result = await graphis.mutate(FORCE_FINISH, {conversation});

        // return result
        return result.data.finishConversation ?? null;
    }

    // failed: log error and return null
    catch (e)
    {
        // get user info
        const {company, id: user} = fetchUser();

        // log error and return null
        logger.error('CVJPZ0068E', {company, conversation, user});
        return null;
    }
}


/**
 * I free a conversation from awaiting customer response state.
 *
 * :param conversation: conversation id
 *
 * :returns: uid of agent who created the conversation, or null
 */
async function freeConversation (conversation: number): Promise<string | null>
{
    // initialize response
    let response: IFreeConversationResponse;

    // try to free conversation
    try
    {
        response = await timeout(
            graphis.mutate(FREE_CONVERSATION, {conversation}),
            5 * SECOND,
        );
    }

    // mutation failed: return null
    catch (error)
    {
        return null;
    }

    // return agent uid on sucess, null otherwise
    return response?.data?.freeConversation || null;
}


/**
 * I fetch real time metrics
 *
 * :returns: promise with metrics or null
 */
async function fetchRealTimeMetrics (): Promise<IRealTimeMetrics | null>
{
    // initialize response
    let response: IFetchRealTimeMetricsResponse;

    // get user info
    const {company, id: user, name} = fetchUser();

    // fetch real time metrics
    try
    {
        response = await graphis.query(FETCH_REALTIME_METRICS);
    }

    // fetch failed: log and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: error.message,
                report: 'realtime',
                user,
            },
        );
        return null;
    }

    // get result
    const result = response?.data?.metrics;

    // load failed: log and return null
    if (result === null ||
        result === undefined ||
        result.__typename === 'Error')
    {
        const error = (result as IGraphisError);
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: `${error?.code}: ${error?.info}`,
                report: 'realtime',
                user,
            },
        );
        return null;
    }

    // get data
    const data = result as unknown as IRealTimeMetricsResponse;

    // initialize real time metrics
    const metrics: IRealTimeMetrics = {
        accounts: {},
        apps: {},
        attending: {
            ...data.attending,
            conversations: data.attending.conversations ?? {
                hasAgentAnswer: [],
                incoming: [],
                outgoing: [],
                total: [],
            },
        },
        chatbot: {
            ...data.chatbot,
            conversations: data.chatbot.conversations ?? {
                hasAgentAnswer: [],
                incoming: [],
                outgoing: [],
                total: [],
            },
        },
        conversations: data.conversations ?? {
            hasAgentAnswer: [],
            incoming: [],
            outgoing: [],
            total: [],
        },
        hasAgentAnswer: data.hasAgentAnswer,
        hasError: false,
        incoming: data.incoming,
        isFetching: false,
        outgoing: data.outgoing,
        queued: {
            ...data.queued,
            conversations: data.queued.conversations ?? {
                hasAgentAnswer: [],
                incoming: [],
                outgoing: [],
                total: [],
            },
        },
        total: data.total,
    };

    // set account metrics
    data.accounts?.map(account =>
    {
        metrics.accounts[account.id] = {
            attending: account.attending,
            chatbot: account.chatbot,
            conversations: account.conversations ?? {
                attending: [],
                chatbot: [],
                hasAgentAnswer: [],
                incoming: [],
                outgoing: [],
                pending: [],
                queued: [],
                total: [],
            },
            hasAgentAnswer: account.hasAgentAnswer,
            incoming: account.incoming,
            outgoing: account.outgoing,
            pending: account.pending,
            queued: account.queued,
            total: account.total,
        };
    });

    // set app metrics
    data.apps.map(app =>
    {
        metrics.apps[app.type] = {
            ...metrics.apps[app.type],
            [app.uid]: {
                attending: app.attending || 0,
                conversations: app.conversations ?? {
                    attending: [],
                    hasAgentAnswer: [],
                    incoming: [],
                    outgoing: [],
                    pending: [],
                    queued: [],
                    total: [],
                },
                hasAgentAnswer: app.hasAgentAnswer,
                incoming: app.incoming,
                outgoing: app.outgoing,
                pending: app.pending || 0,
                queued: app.queued || 0,
                total: app.total,
            },
        };
    });

    // fetch succeeded: return metrics
    return metrics;
}


/**
 * I get the conversation's agent name.
 *
 * :param conversation: conversation data
 *
 * :returns: agent name or null
 */
function getConversationAgentName(
    conversation: IConversationsReportMetric,
): string | null
{
    // get conversation attributes
    const {
        agentFinished,
        direction,
        end,
        firstAgent,
        lastApp,
        lastUid,
    } = conversation;

    // is an ongoing conversation: return null
    if (end === null)
    {
        return null;
    }

    // is an incoming conversation: set agent name
    if (direction !== 'outgoing' && direction !== 'echo')
    {
        // is an answered conversation: return agent name
        if (agentFinished !== null)
        {
            return getAgentName(agentFinished);
        }

        // is a lost conversation: return agent name
        if (lastApp === 'agent' && lastUid !== null)
        {
            return getAgentName(lastUid);
        }
    }

    // is an outgoing conversation and have a first answer: return agent name
    else if (firstAgent !== null)
    {
        return getAgentName(firstAgent);
    }

    // return fallback to agent name
    return 'N/A';
}


/**
 * I fetch quality conversations.
 *
 * :param from: start date
 * :param to: end date
 * :param accounts: accounts filter
 * :param queue: queue filter
 * :param agent: agent filter
 * :param scores: scores filter
 *
 * :returns: quality conversations or null
 */
async function getQualityReport(
    from: number,
    to: number,
    accounts: number[] | null,
    queue: string | null,
    agent: string | null,
    scores: number[] | null,
): Promise<IQualityReportResult>
{
    // initialize result
    let result: IFetchQualityConversationsResponse;

    // get user data
    const {company, id: user, name} = getUser();

    // set query params
    const params = {from, to} as Record<string, unknown>;

    // has accounts filter
    if (accounts !== null)
    {
        params.accounts = accounts;
    }

    // has queue filter
    if (queue !== null)
    {
        params.queue = queue;
    }

    // has agent filter
    if (agent !== null)
    {
        params.agent = agent;
    }

    // has scores filter
    if (scores !== null)
    {
        params.score = scores;
    }

    // fetch quality report
    try
    {
        result = await graphis.query(FETCH_QUALITY_REPORT, params);
    }

    // failed: log error and return null
    catch (error)
    {
        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: error.message,
                report: 'quality',
                user,
            },
        );
        return {error: null, rows: null};
    }

    // get result
    const metrics = result.data.metrics;

    // failed: log error and return the code
    if (metrics === null ||
        metrics === undefined ||
        metrics.__typename === 'Error')
    {
        // get the refusal, if any
        const error = metrics?.__typename === 'Error' ? metrics : null;

        logger.error(
            'CVJPZ0071E',
            {
                company,
                name,
                reason: error === null ?
                    'empty response' :
                    `${error.code}: ${error.info}`,
                report: 'quality',
                user,
            },
        );
        return {error: error?.code ?? null, rows: null};
    }

    // return quality report conversations
    return {error: null, rows: (metrics as IQualityReportRows).rows};
}


/**
 * I dispatch the quality analysis of conversations.
 *
 * :param conversations: conversation ids, at most MAX_DISPATCH
 *
 * :returns: analysis groups, or the error code
 */
async function analyzeConversations(
    conversations: number[],
): Promise<IAnalyzeConversationsResult>
{
    // initialize response
    let response: IAnalyzeConversationsResponse;

    // get user data
    const {company, id: user, name} = getUser();

    // dispatch analysis
    try
    {
        response = await graphis.mutate<
            IAnalyzeConversations,
            IAnalyzeConversationsVariables
        >(ANALYZE_CONVERSATIONS, {conversations});
    }

    // request failed: log and return without a code
    catch (error)
    {
        logger.error(
            'CVJPZ0101E',
            {
                company,
                conversations: conversations.length,
                name,
                reason: error.message,
                user,
            },
        );
        return {error: null};
    }

    // get result
    const result = response.data?.analyzeConversations;

    // backend refused the request: log and return the code
    if (result === undefined || result.__typename === 'Error')
    {
        // get the refusal, if any
        const refusal = result?.__typename === 'Error' ? result : null;

        // log error
        logger.error(
            'CVJPZ0101E',
            {
                company,
                conversations: conversations.length,
                name,
                reason: refusal === null ?
                    'empty response' :
                    `${refusal.code}: ${refusal.info}`,
                user,
            },
        );
        return {error: refusal?.code ?? null};
    }

    // return groups
    return {
        alreadyAnalyzed: result.alreadyAnalyzed,
        dispatched: result.dispatched,
        error: null,
        rejected: result.rejected,
    };
}


/**
 * I load ongoing conversations for an agent.
 *
 * :param agent: agent id
 * :param company: company id
 *
 * :returns: promise with conversations
 */
async function load (agent: string,
                     company: number): Promise<IOngoingConversation[] | null>
{
    // initialize result
    let result: IFetchOngoingConversationsResponse;

    // load conversations
    try
    {
        result = await graphis.query(
            FETCH_ONGOING_CONVERSATIONS,
            {agent, company},
        );
    }

    // load failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // load failed: return null
    if (result.data.ongoingConversations === null)
    {
        return null;
    }

    // load succeeded: return conversations
    return result.data.ongoingConversations;
}


/**
 * I load agent conversations by period of time.
 *
 * :param agent: agent id
 * :param company: company id
 * :param from: period start timestamp in unix seconds
 * :param to: period end timestamp in unix seconds
 *
 * :returns: promise with conversations
 */
async function loadByPeriod (
    agent: string,
    company: number,
    from: number,
    to: number,
): Promise<IConversationLoaded[] | null>
{
    // convert times to seconds
    const secondsFrom = Math.floor(from / 1000);
    const secondsTo = Math.floor(to / 1000);

    // initialize result
    let result: IFetchAgentConversationsResponse;

    // load conversations
    try
    {
        result = await graphis.query(
            FETCH_AGENT_CONVERSATIONS,
            {agent, company, from: secondsFrom, to: secondsTo},
        );
    }

    // load failed: log error and return null
    catch (e)
    {
        logger.error('CVJPZ0017E', {agent, reason: `${e.name}: ${e.message}`});
        return null;
    }

    // load failed: log error and return null
    if (result.data.conversations === null)
    {
        logger.error('CVJPZ0017E', {agent, reason: 'No data returned.'});
        return null;
    }

    // load succeeded: return conversations
    return result.data.conversations;
}


/**
 * I load the conversation customer.
 *
 * :param conversation: customer conversation
 *
 * :returns: promise with customer id
 */
async function loadConversationCustomer(
    conversation: IBaseConversation,
): Promise<string | number>
{
    return await customersUtils.ensureCustomer(
        conversation.account?.channel?.toLowerCase() ?? '',
        conversation.contact.name,
        conversation.contact.uid,
        false,
        conversation.contact.username,
    );
}


/**
 * I get all online angets of a company.
 *
 * :param company: company id
 *
 * :returns: promise with agents
 */
async function getOnlineAgents (company: number): Promise<IAgentSession[]>
{
    // initialize response
    let response: IFetchAgentsResponse;

    // fetch agents
    try
    {
        response = await graphis.query(FETCH_AGENTS, {company});
    }

    // fetch failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint disable-line no-console
        return null;
    }

    // fetch succeeded: return agents
    return response.data.agents;
}


/**
 * I increase agents metrics,
 *
 * :param agents: initial agents metrics
 * :param conversation: conversation data
 *
 * :returns: updated agents metrics
 */
function increaseAgentsMetrics(
    agents: IConversationsMetricsByAgent,
    conversation: IConversationMetrics,
): IConversationsMetricsByAgent
{
    // spread conversation data
    const {
        agentFinished,
        attendanceTime,
        direction,
        end,
        firstAgent,
        id,
        lastApp,
        lastStatus,
        lastUid,
        waitTime,
    } = conversation;

    // initialize metrics by agent
    let byAgent: IConversationsMetricsByAgent = agents ?? {};

    // set default time
    const DEFAULT_TIME: ITotalTime = {conversations: 0, time: 0};

    // initialize metrics
    const answered = agents?.[agentFinished ?? lastUid]?.answered ?? [];
    const lost = agents?.[lastUid]?.lost ?? [];
    const outgoing = agents?.[firstAgent]?.outgoing ?? [];
    const attendance = agents?.[agentFinished ?? lastUid]?.attendance ??
                    {...DEFAULT_TIME};
    const wait = agents?.[firstAgent]?.wait ?? {...DEFAULT_TIME};

    // have a first answer: set metrics
    if (direction === 'incoming' && firstAgent !== null)
    {
        // have a wait time: increase wait props
        if (waitTime !== null)
        {
            wait.conversations = wait.conversations + 1;
            wait.time = wait.time + waitTime;
        }

        // set metrics
        byAgent = {
            ...byAgent,
            [firstAgent]: {
                ...byAgent[firstAgent],
                wait,
            },
        };
    }

    // is lost: push to list
    if (direction === 'incoming' &&
        end !== null &&
        lastApp === 'agent' &&
        lastUid !== null &&
        agentFinished === null &&
        lastStatus !== NO_MESSAGE)
    {
        byAgent = {
            ...byAgent,
            [lastUid]: {
                ...byAgent[lastUid],
                lost: [...lost, id],
            },
        };
    }

    // is answered: set metrics
    if (direction === 'incoming' &&
        end !== null &&
        lastApp === 'agent' &&
        lastUid !== null &&
        (agentFinished !== null ||
        lastStatus === NO_MESSAGE))
    {
        // have an attendance time: increase attendance props
        if (attendanceTime !== null)
        {
            attendance.conversations = attendance.conversations + 1;
            attendance.time = attendance.time + attendanceTime;
        }

        // set agent uid
        const uid = agentFinished ?? lastUid;

        // set metrics
        byAgent = {
            ...byAgent,
            [uid]: {
                ...byAgent[uid],
                answered: [...answered, id],
                attendance,
            },
        };
    }

    // is outgoing: push to list
    if (direction === 'outgoing' && firstAgent !== null)
    {
        byAgent = {
            ...byAgent,
            [firstAgent]: {
                ...byAgent[firstAgent],
                outgoing: [...outgoing, id],
            },
        };
    }

    // return metrics by agent
    return byAgent;
}


/**
 * I increase conversation metrics.
 *
 * :param initialMetrics: initial conversation metrics
 * :param conversation: conversation data
 *
 * :returns: updated conversation metrics
 */
function increaseConversationMetrics(
    initialMetrics: IConversationBasicMetrics,
    conversation: IConversationMetrics,
): IConversationBasicMetrics
{
    // initialize metrics
    let metrics: IConversationBasicMetrics = {
        answered: {conversations: [], count: 0},
        chatbot: {conversations: [], count: 0},
        conversations: [],
        finished: {conversations: [], count: 0},
        incoming: {conversations: [], count: 0},
        lost: {conversations: [], count: 0},
        ongoing: {conversations: [], count: 0},
        outgoing: {conversations: [], count: 0},
        outgoingAgent: {conversations: [], count: 0},
        outgoingSystem: {conversations: [], count: 0},
    };

    // has initial metrics: use it as initial value
    if (initialMetrics !== undefined)
    {
        metrics = initialMetrics;
    }

    // is ongoing: push to list
    if (conversation.end === null)
    {
        metrics.ongoing.conversations.push(conversation.id);
        metrics.ongoing.count += 1;
    }

    // is finished: push to list
    else
    {
        metrics.finished.conversations.push(conversation.id);
        metrics.finished.count += 1;
    }

    // is incoming: push to list
    if (conversation.direction === 'incoming')
    {
        metrics.incoming.conversations.push(conversation.id);
        metrics.incoming.count += 1;
    }

    // is outgoing: push to list
    if (conversation.direction === 'outgoing')
    {
        metrics.outgoing.conversations.push(conversation.id);
        metrics.outgoing.count += 1;

        // is answered by system: push to respective list
        if (conversation.firstAgent === 'system')
        {
            metrics.outgoingSystem.conversations.push(conversation.id);
            metrics.outgoingSystem.count += 1;
        }

        // is answered by agent: push to respective list
        else
        {
            metrics.outgoingAgent.conversations.push(conversation.id);
            metrics.outgoingAgent.count += 1;
        }
    }

    // is lost: push to list
    if (conversation.direction === 'incoming' &&
        conversation.end !== null &&
        conversation.lastApp === 'agent' &&
        conversation.lastUid !== null &&
        conversation.agentFinished === null &&
        conversation.lastStatus !== NO_MESSAGE)
    {
        metrics.lost.conversations.push(conversation.id);
        metrics.lost.count += 1;
    }

    // is answered: push to list
    if (conversation.direction === 'incoming' &&
        conversation.end !== null &&
        conversation.lastApp === 'agent' &&
        conversation.lastUid !== null &&
        (conversation.agentFinished !== null ||
        conversation.lastStatus === NO_MESSAGE))
    {
        metrics.answered.conversations.push(conversation.id);
        metrics.answered.count += 1;
    }

    // is a chatbot conversation: push to list
    if (conversation.direction === 'incoming' &&
        conversation.end !== null &&
        conversation.agentFinished === null &&
        conversation.lastApp !== 'agent')
    {
        metrics.chatbot.conversations.push(conversation.id);
        metrics.chatbot.count += 1;
    }

    // push conversation to list
    metrics.conversations.push(conversation.id);

    // return conversation metrics
    return metrics;
}


/**
 * I increase times metrics.
 *
 * :param initialMetrics: initial times metrics
 * :param conversation: conversation data
 *
 * :returns: updated metrics
 */
function increaseTimesMetrics(
    initialMetrics: ITimesMetrics,
    conversation: IConversationMetrics,
): ITimesMetrics
{
    // initialize times metrics
    let metrics: ITimesMetrics = initialMetrics;

    // no initial metrics: initialize with default values
    if (initialMetrics === undefined)
    {
        metrics = {
            attendance: {conversations: 0, time: 0},
            chatbot: {conversations: 0, time: 0},
            firstAnswer: {conversations: 0, time: 0},
        };
    }

    // has first answer wait time: push to metrics
    if (conversation.direction === 'incoming' &&
        conversation.firstAgent !== null &&
        conversation.waitTime !== null)
    {
        metrics.firstAnswer.conversations += 1;
        metrics.firstAnswer.time += conversation.waitTime;
    }

    // has attendance time: push to metrics
    if (conversation.direction === 'incoming' &&
        conversation.end !== null &&
        conversation.lastApp === 'agent' &&
        conversation.lastUid !== null &&
        (conversation.agentFinished !== null ||
        conversation.lastStatus === NO_MESSAGE) &&
        conversation.attendanceTime !== null)
    {
        metrics.attendance.conversations += 1;
        metrics.attendance.time += conversation.attendanceTime;
    }

    // has chatbot time: push to metrics
    if (conversation.direction === 'incoming' &&
        conversation.end !== null &&
        conversation.agentFinished === null &&
        conversation.lastApp !== 'agent' &&
        conversation.chatbotTime !== null)
    {
        metrics.chatbot.conversations += 1;
        metrics.chatbot.time += conversation.chatbotTime;
    }

    // return updated times metrics
    return metrics;
}


/**
 * I move a customer id from ongoing to history, if needed.
 *
 * :param channel: conversation channel of whose customer must be moved
 * :param uid: conversation contact uid of whose customer must be moved
 * :param conversations: conversation byId
 * :param historyState: state history array
 * :param ongoingState: state ongoing array
 *
 * :returns: updated history and ongoing
 */
function moveToHistory (
    channel: string,
    uid: string,
    conversations: any,
    historyState: (number | string)[],
    ongoingState: (number | string)[],
): IHistoryOngoing
{
    // store history and ongoing from state
    let history = historyState;
    let ongoing = ongoingState;

    // get conversation's customer
    const customer = customers.getCustomerByContact(
        customersUtils.contactTypesChannelToId.get(channel.toLowerCase()),
        uid,
    );

    // get number of conversations with the customer
    let count = 0;
    Object.values(conversations).forEach ((conversation: any): void =>
    {
        // get customer index on ongoing
        const conversationCustomer = customers.getCustomerByContact(
            customersUtils.contactTypesChannelToId.get(
                conversation.channel.toLowerCase(),
            ),
            conversation.remote,
        );

        // conversation with customer: increment count
        if (conversationCustomer.id === customer.id)
        {
            count += 1;
        }
    });

    // last ongoing conversation with the customer: move it to history
    if (count === 1)
    {
        // copy history and ongoing
        history = [...historyState];
        ongoing = [...ongoingState];

        // get customer index on ongoing
        const index = ongoing.findIndex(
            (element: number | string): boolean => (
                element === customer.id
            ),
        );

        // remove customer from ongoing
        ongoing.splice(index, 1);

        // add customer to begining of history
        history.unshift(customer.id);
    }

    // return history and ongoing
    return {
        history,
        ongoing,
    };
}


/**
 * I move a customer id from history to top of ongoing or just add/move it to
 * the top of ongoing (if it does not exist on history).
 *
 * :param customerId: id of customer that has to be moved
 * :param historyState: state history array
 * :param historyState: state ongoing array
 *
 * :returns: updated history and ongoing
 */
function moveToOngoing (
    customerId: (number | string),
    historyState: (number | string)[],
    ongoingState: (number | string)[],
): IHistoryOngoing
{
    // get history and copy ongoing
    let history = historyState;
    const ongoing = [...ongoingState];

    // get index on ongoing
    const indexOngoing = ongoing.findIndex(
        (element: number | string): boolean => (
            element === customerId
        ),
    );

    // customer exist on ongoing: remove it
    if (indexOngoing !== -1)
    {
        ongoing.splice(indexOngoing, 1);
    }

    // customer does not exist on ongoing: search it on history
    else
    {
        // get index on history
        const indexHistory = history.findIndex(
            (element: number | string): boolean => (
                element === customerId
            ),
        );

        // customer exists on history: copy history and remove it
        if (indexHistory !== -1)
        {
            history = [...historyState];
            history.splice(indexHistory, 1);
        }
    }

    // add customer to begining of ongoing
    ongoing.unshift(customerId);

    // return updated ongoing and history
    return {
        history,
        ongoing,
    };
}


/**
 * I move a customer id to the top of customer ids array.
 *
 * :param channel: customer's contact channel
 * :param uid: customer's contact uid
 * :param customers: customer ids array
 *
 * :returns: customer ids array with the customer id moved to the top
 */
function moveToTop (
    channel: string,
    uid: string,
    customerIds: (number | string)[],
): (number | string)[]
{
    // get conversation's customer
    const customer = customers.getCustomerByContact(
        customersUtils.contactTypesChannelToId.get(channel),
        uid,
    );

    // customer not found: return customer ids unchanged
    if (customer === null)
    {
        return customerIds;
    }

    // get customer index on customer ids array
    const index = customerIds.findIndex(
        (element: number | string): boolean => (
            element === customer.id
        ),
    );

    // copy customer ids array
    const customerIdsCopy = [...customerIds];

    // customer exists on customer ids array: remove it
    if (index !== -1)
    {
        customerIdsCopy.splice(index, 1);
    }

    // move customer to the first position of customer ids array
    customerIdsCopy.unshift(customer.id);

    // return updated customer ids array
    return customerIdsCopy;
}


/**
 * I check if a template is needed to send a message to contact now.
 *
 * :param account: account id
 * :param contact: contact uid
 *
 * :returns: promise with boolean or null
 */
async function needTemplate (
    account: string,
    contact: string,
): Promise<boolean | null>
{
    // initialize result
    let result: INeedTemplateResponse;

    // run query
    try
    {
        result = await timeout(
            graphis.query(NEED_TEMPLATE, {account, contact}),
            5 * SECOND,
        );
    }

    // query failed: return null
    catch (error)
    {
        return null;
    }

    // response failed: return null
    if (typeof result?.data?.needTemplate !== 'boolean')
    {
        return null;
    }

    // response succeeded: return whether a template is needed or not
    return result?.data?.needTemplate === true;
}


/**
 * I reduce agents metrics.
 *
 * :param agents: agents data to calculate metrics
 *
 * :returns: metrics by agent
 */
function reduceAgentsMetrics(
    agents: IConversationsMetricsByAgent,
): IAgentsMetricsById
{
    // initialize metrics by agent
    const byAgent: IAgentsMetricsById = {};

    // calculate averange times
    for (const uid in agents)
    {
        // initialize average times
        let averageAttendance = null;
        let averageWait = null;

        // have attended conversations: set average time
        if (agents[uid].attendance?.conversations > 0)
        {
            averageAttendance = agents[uid].attendance.time /
                                agents[uid].attendance.conversations;
        }

        // have answered conversations: set average time
        if (agents[uid].wait?.conversations > 0)
        {
            averageWait = agents[uid].wait.time /
                          agents[uid].wait.conversations;
        }

        // set conversations metrics by agent
        byAgent[uid] = {
            answered: {
                conversations: agents[uid].answered ?? [],
                count: agents[uid].answered?.length ?? 0,
            },
            averageAttendance,
            averageWait,
            lost: {
                conversations: agents[uid].lost ?? [],
                count: agents[uid].lost?.length ?? 0,
            },
            outgoing: {
                conversations: agents[uid].outgoing ?? [],
                count: agents[uid].outgoing?.length ?? 0,
            },
            templatesSent: null,
            uid,
        };
    }

    // return metrics by agent
    return byAgent;
}


/**
 * I reduce a conversation.
 *
 * :param conversation: conversation
 *
 * :returns: reduced conversation
 */
const reduceConversation = (conversation: any): IConversation =>
{
    // get conversation properties
    const {account} = conversation;
    const {channel} = account;
    const {contact} = conversation;
    const {id} = conversation;
    const {uid} = contact;

    // initialize reduced conversation
    const reduced = {...conversation};

    // get messages
    let {messages} = conversation;

    // find last outgoing message
    const lastOutgoing = findLastIndex(
        messages,
        (message: ITimelineMessage): boolean => message.outgoing !== null,
    );

    // get messages amount after last outgoing
    const unansweredMessages = messages.length - lastOutgoing - 1;

    // map message properties
    messages = conversation.messages.map((message): object => ({
        ...message,
        ack: message.ack,
        conversation: id,
        name: null,
        outgoing: message.outgoing !== null,
        timestamp: message.timestamp * 1000,
        uid,
    }));

    // set conversation start time
    const startTime = conversation.start * 1000;

    // initialize last interaction and messages object
    let lastInteraction = startTime;
    const messagesById = {};

    // set last interaction and index messages by id
    for (const message of messages)
    {
        // set last interaction
        lastInteraction = message.timestamp;

        // index messages by id
        messagesById[message.id] = message;
    }

    // return reduced conversation
    return {
        ...reduced,
        attachments: {},
        channel,
        id,
        lastInteraction,
        messages: messagesById,
        remote: uid,
        startTime: conversation.start * 1000,
        unansweredMessages,
    };
};


/**
 * I reduce conversations metrics.
 *
 * :param conversations: conversations report
 * :param start: start date
 * :param end: end date
 *
 * :returns: reduced conversations
 */
const reduceConversationsMetrics = (
    conversations: IConversationsReportMetric[],
    start: number,
    end: number,
): IConversationsMetrics =>
{
    // initialize results
    const contacts = new Set<string>();
    let agents: IConversationsMetricsByAgent = {};
    const agentsByQueue: IAgentsByQueue = {};
    const agentsByAccount: IAgentsByAccount = {};
    const agentsByAccountAndQueue: IAgentsByAccountAndQueue = {};
    const contactsByAccount: IContactsByAccount = {};
    const contactsByQueue: IContactsByQueue = {};
    const contactsByAccountAndQueue: IContactsByAccountAndQueue = {};
    const result: IConversationsMetrics = {
        answered: {conversations: [], count: 0},
        byAccount: {},
        byAgent: {},
        byPeriod: {},
        byQueue: {},
        chatbot: {conversations: [], count: 0},
        contacts: [],
        conversations: [],
        finished: {conversations: [], count: 0},
        incoming: {conversations: [], count: 0},
        lost: {conversations: [], count: 0},
        ongoing: {conversations: [], count: 0},
        outgoing: {conversations: [], count: 0},
        outgoingAgent: {conversations: [], count: 0},
        outgoingSystem: {conversations: [], count: 0},
        times: {
            attendance: {conversations: 0, time: 0},
            chatbot: {conversations: 0, time: 0},
            firstAnswer: {conversations: 0, time: 0},
        },
    };

    // get periods
    const periods = getPeriods(end, start);
    const byPeriod: IMetricsByPeriod = periods.reduce((byPeriod, period) => ({
        ...byPeriod,
        [period]: {
            incoming: 0,
            outgoing: 0,
        },
    }), {} as IMetricsByPeriod);

    // get interval between periods
    const interval = Math.abs(periods[0] - periods[1]);

    // set conversations metrics by agent
    for (const key in conversations)
    {
        // get conversation props
        const conversation = reduceConversationReport(conversations[key]);

        // check conversation period
        periods.forEach((period, index) =>
        {
            // set period limit
            const end = periods[index + 1] ?? period + interval;

            // get conversation start timestamp
            const startTime = conversation.start * 1000;

            // conversation wasn't created in period range: continue
            if (startTime < period || startTime >= end)
            {
                return;
            }

            // conversation is incoming: add to period
            if (conversation.direction === 'incoming')
            {
                byPeriod[period].incoming += 1;
            }

            // conversation is outgoing: add to period
            if (conversation.direction === 'outgoing')
            {
                byPeriod[period].outgoing += 1;
            }
        });

        // push contact to list
        contacts.add(conversation.contactUid);

        // increase agents metrics
        const agentsMetrics = increaseAgentsMetrics(agents, conversation);

        // update agents metrics
        agents = agentsMetrics;

        // increase conversation metrics
        const metrics = increaseConversationMetrics(result, conversation);

        // increase times metrics
        const times = increaseTimesMetrics(result.times, conversation);

        // update conversation metrics
        result.answered = metrics.answered;
        result.chatbot = metrics.chatbot;
        result.conversations = metrics.conversations;
        result.finished = metrics.finished;
        result.incoming = metrics.incoming;
        result.lost = metrics.lost;
        result.ongoing = metrics.ongoing;
        result.outgoing = metrics.outgoing;
        result.outgoingAgent = metrics.outgoingAgent;
        result.outgoingSystem = metrics.outgoingSystem;
        result.times = times;

        // increase conversation metrics
        const accountMetrics = increaseConversationMetrics(
            result.byAccount[conversation.account],
            conversation,
        );

        // increase agents metrics
        const accountAgentsMetrics = increaseAgentsMetrics(
            agentsByAccount[conversation.account],
            conversation,
        );

        // update agents metrics
        agentsByAccount[conversation.account] = accountAgentsMetrics;

        // increase times metrics
        const accountTimes = increaseTimesMetrics(
            result.byAccount[conversation.account]?.times,
            conversation,
        );

        // new account in list: initialize contacts
        if (contactsByAccount[conversation.account] === undefined)
        {
            contactsByAccount[conversation.account] = new Set();
        }

        // push contact to list
        contactsByAccount[conversation.account].add(conversation.contactUid);

        // update account metrics
        result.byAccount[conversation.account] = {
            ...result.byAccount[conversation.account],
            ...accountMetrics,
            byAgent: {},
            contacts: [],
            times: accountTimes,
        };

        // has queue: calc queue metrics
        if (conversation.queue !== null && conversation.queue !== undefined)
        {
            // increase conversation metrics
            const metrics = increaseConversationMetrics(
                result.byQueue[conversation.queue],
                conversation,
            );

            // increase conversation metrics
            const accountMetrics = increaseConversationMetrics(
                result.byAccount[conversation.account]
                    ?.byQueue?.[conversation.queue],
                conversation,
            );

            // increase agents metrics
            const agentsMetrics = increaseAgentsMetrics(
                agentsByQueue[conversation.queue],
                conversation,
            );

            // increase agents metrics
            const accountAgentsMetrics = increaseAgentsMetrics(
                agentsByAccountAndQueue[conversation.account]
                    ?.[conversation.queue],
                conversation,
            );

            // update agents metrics for queue and account
            agentsByAccountAndQueue[conversation.account] = {
                ...agentsByAccountAndQueue[conversation.account],
                [conversation.queue]: {
                    ...accountAgentsMetrics,
                },
            };

            // increase times metrics by queue
            const times = increaseTimesMetrics(
                result.byQueue[conversation.queue]?.times,
                conversation,
            );

            // increase times metrics by queue and account
            const accountTimes = increaseTimesMetrics(
                result.byAccount[conversation.account]
                    ?.byQueue?.[conversation.queue]?.times,
                conversation,
            );

            // update agents metrics
            agentsByQueue[conversation.queue] = agentsMetrics;

            // new queue in list: initialize contacts
            if (contactsByQueue[conversation.queue] === undefined)
            {
                contactsByQueue[conversation.queue] = new Set();
            }

            // push contact to list
            contactsByQueue[conversation.queue].add(conversation.contactUid);

            // new account/queue in list: initialize contacts
            if (contactsByAccountAndQueue[conversation.account]
                ?.[conversation.queue] === undefined)
            {
                contactsByAccountAndQueue[conversation.account] = {
                    ...contactsByAccountAndQueue[conversation.account],
                    [conversation.queue]: new Set(),
                };
            }

            // push contact to list
            contactsByAccountAndQueue[conversation.account][conversation.queue]
                .add(conversation.contactUid);

            // update queue metrics
            result.byQueue[conversation.queue] = {
                ...metrics,
                byAgent: {},
                contacts: [],
                times,
            };

            // update account metrics
            result.byAccount[conversation.account] = {
                ...result.byAccount[conversation.account],
                byQueue: {
                    ...result.byAccount[conversation.account]?.byQueue,
                    [conversation.queue]: {
                        ...accountMetrics,
                        byAgent: {},
                        contacts: [],
                        times: accountTimes,
                    },
                },
            };
        }
    }

    // set metrics by period
    result.byPeriod = byPeriod;

    // set metrics by agent
    result.byAgent = reduceAgentsMetrics(agents);

    // set contacts result
    result.contacts = Array.from(contacts);

    // for each queue: calc metrics
    Object.keys(result.byQueue).forEach(queue =>
    {
        // calc agents metrics
        result.byQueue[queue].byAgent = reduceAgentsMetrics(
            agentsByQueue[queue],
        );

        // convert contact list
        result.byQueue[queue].contacts = Array.from(contactsByQueue[queue]);
    });

    // for each account: calc metrics
    Object.keys(result.byAccount).forEach(account =>
    {
        // calc agents metrics by account
        result.byAccount[account].byAgent = reduceAgentsMetrics(
            agentsByAccount[account],
        );

        // convert contact list
        result.byAccount[account]
            .contacts = Array.from(contactsByAccount[account]);

        // for each queue in account: calc metrics
        Object.keys(result.byAccount[account]?.byQueue ?? {}).forEach(queue =>
        {
            // calc agents metrics
            result.byAccount[account]
                .byQueue[queue].byAgent = reduceAgentsMetrics(
                    agentsByAccountAndQueue[account][queue],
                );

            // convert contact list
            result.byAccount[account].byQueue[queue].contacts = Array.from(
                contactsByAccountAndQueue[account][queue],
            );
        });
    });

    // return reduced conversations
    return result;
};


/**
 * I reduce a conversation report.
 *
 * :param conversation: conversation data
 *
 * :returns: reduced conversation
 */
const reduceConversationReport = (
    conversation: IConversationsReportMetric,
): IConversationMetrics =>
{
    // initialize times
    let attendanceTime = null;
    let waitTime = null;
    let chatbotTime = null;

    // get conversation props
    const {
        account: accountId,
        agentFinished,
        end,
        contactUid,
        direction: apiDirection,
        finished,
        firstAgent,
        firstAnswer,
        id,
        lastApp,
        lastStatus,
        lastUid,
        queue,
        start,
    } = conversation;

    // treat echo as outgoing
    const direction = apiDirection === 'echo' ? 'outgoing' : apiDirection;

    // conversation has a first answer: set wait time
    if (direction === 'incoming' && firstAnswer !== null)
    {
        waitTime = firstAnswer - start;
    }

    // conversation was finished: set attendance time
    if (direction === 'incoming' &&
        firstAnswer !== null &&
        finished !== null)
    {
        attendanceTime = finished - firstAnswer;
    }

    // conversations finished by chatbot: set chatbot time
    if (direction === 'incoming' &&
        end !== null &&
        agentFinished === null &&
        lastApp !== 'agent')
    {
        chatbotTime = end - start;
    }

    // get account data
    const account = accountSelectors.get(accountId);

    // get conversation from state
    const stored = conversationSelectors.getFinished(id);

    // return reduced data
    return {
        ...stored,
        account: accountId,
        agentFinished,
        agentName: getConversationAgentName(conversation),
        attendanceTime,
        channel: account?.channel ?? '',
        chatbotTime,
        contactUid,
        customer: null,
        direction,
        end: end * 1000 || null,
        firstAgent,
        firstAnswer,
        id,
        lastApp,
        lastStatus,
        lastUid,
        queue,
        start,
        waitTime,
    };
};


/**
 * I remove an id from history or ongoing.
 *
 * :param id: id to be removed
 * :param history: history list
 * :param ongoing: ongoing list
 *
 * :returns: updated history and ongoing
 */
function removeId (
    id: (number | string),
    history: (number | string)[],
    ongoing: (number | string)[],
): IHistoryOngoing
{
    // get index of id in ongoing
    const indexOngoing = ongoing.findIndex(
        (element: number | string): boolean => (element === id),
    );

    // id exists on ongoing: remove it
    if (indexOngoing !== -1)
    {
        ongoing.splice(indexOngoing, 1);
    }

    // id does not exist on ongoing: search for it on history
    else
    {
        // get index of id in history
        const indexHistory = history.findIndex(
            (element: number | string): boolean => (element === id),
        );

        // id exists on history: remove it
        if (indexHistory !== -1)
        {
            history.splice(indexHistory, 1);
        }
    }

    // return updated ongoing and history
    return {
        history,
        ongoing,
    };
}


/**
 * I move conversations from given account and contact that didn't go to
 * timeline.
 *
 * :param accountId: accountId
 * :param contactUid: contact uid
 * :param currentConversationId: current conversation id
 *
 * :returns: promise with nothing
 */
async function removePreviousConversations (
    accountId: number,
    contactUid: string,
    currentConversationId: number,
): Promise<void>
{
    // move previous conversations to timeline
    for (const conversation of conversationSelectors.listConversationsByContact(
        accountId,
        contactUid,
    ))
    {
        // previous conversation: move it to timeline
        if (conversation.id !== currentConversationId)
        {
            await removeAPI(conversation.id);
        }
    }
}


/**
 * I retry to send a message to a conversation.
 *
 * :param company: company id
 * :param id: conversation id
 * :param messageId: message id
 *
 * :returns: promise with nothing
 */
async function retryMessage (
    company: number,
    id: number,
    messageId: number,
): Promise<IRetryMessageResult>
{
    // initialize result
    let result: any;

    const variables = {company: company, conversationId: id, messageId};

    // retry message request
    try
    {
        result = await graphis.mutate(RETRY_MESSAGE, variables);
    }

    // send message failed: log and fail with unknown reason
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return {error: 'unknown', id: null};
    }

    // get result data props
    const {retryMessage} = result.data;

    // send failed with specific error: log and return it
    if (retryMessage?.__typename === 'Error')
    {
        console.error(retryMessage.code);
        return {error: retryMessage.code, id: null};
    }

    // success: return message id
    return {error: null, id: retryMessage.id ?? null};
}


/**
 * I send a message to a conversation.
 *
 * body: message body
 * caption: message caption
 * company: agent company
 * contact: contact to send
 * conversation: message conversation
 * originalId: message original id
 * sender: sender id
 * type: message payload type
 * reply: replied message id
 *
 * :returns: promise with nothing
 */
async function sendMessage (
    body: string,
    company: number,
    contact: string,
    conversation: number,
    originalId: string,
    sender: string,
    type: number,
    caption?: string,
    reply?: string,
): Promise<ISendMessageResult>
{
    let response: ISendMessageResponse;

    // try send message request
    try
    {
        // send message
        response = await timeout(
            graphis.mutate(SEND_MESSAGE, {
                body,
                caption,
                company,
                contact,
                conversation,
                originalId,
                reply,
                sender,
                type,
            }),
            TIMEOUT,
        );
    }

    // send message failed: log and fail with unknown reason
    catch (error)
    {
        logger.error('CVJPZ0040E', {
            contact,
            type,
            user: fetchUser().id,
        });
        return {id: null, reason: REASON_UNKNOWN};
    }

    // get sent message
    const {sendMessage} = response.data;

    // send failed with specific error: log and return it
    if (sendMessage?.__typename === 'Error')
    {
        logger.error('CVJPZ0040E', {
            contact,
            type,
            user: fetchUser().id,
        });
        return {id: null, reason: sendMessage.code};
    }

    // send failed with other reason: log and return unknown
    if (sendMessage === null)
    {
        logger.error('CVJPZ0040E', {
            contact,
            type,
            user: fetchUser().id,
        });
        return {id: null, reason: REASON_UNKNOWN};
    }

    // return sended message info
    return {...sendMessage, reason: null};
}


/**
 * I send the selected autoAnswer to a customer.
 *
 * :param uid: command uid
 * :param conversation: conversation
 *
 * :returns: wether auto answer is sent
 */
async function sendAutoAnswer(
    uid: string,
    conversation: number,
): Promise<boolean>
{
    // get user state
    const user = fetchUser();

    // get user preferences
    const {autoMessages} = fetchPreferences(Number(user.id));

    // get current message id
    const currentMessage = autoMessages.current;

    // user status is not away or current auto message is null or undefined:
    // return without sending
    if (user.status !== Statuses.AWAY ||
        currentMessage === null ||
        currentMessage === undefined)
    {
        return false;
    }

    // auto message has already been sent: return as sent
    if (AUTO_MESSAGE_SENT_BY_CONVERSATION[conversation] === true)
    {
        return true;
    }

    // get isAutoAnswered from conversation state
    const {isAutoAnswered} = conversationSelectors.get(conversation);

    // current auto message was already sent: return without sending
    if (isAutoAnswered === true)
    {
        return false;
    }

    // set current auto message to body
    const body = autoMessages.byId[currentMessage];

    // no current auto message found: return without sending
    if (body === undefined || body === null || body === '')
    {
        return false;
    }

    // set conversation auto message as sent
    AUTO_MESSAGE_SENT_BY_CONVERSATION[conversation] = true;

    // get current date
    const now = Date.now();

    // set message
    const message: IMessage = {
        attachments: [],
        body,
        originalId: `${conversation}.${now}.${uuid4()}`,
        outgoing: user.id,
        timestamp: now,
        type: 0,
    };

    // send specified message
    await sendMessageAPI(uid, conversation, message);

    // current auto message sent
    return true;
}


/**
 * I send an agent's paused and away status.
 *
 * :param agent: agent id
 * :param away: agent's away status
 * :param paused: agent's paused status
 *
 * :returns: promise with nothing
 */
async function sendPaused (
    agent: string,
    away: boolean,
    paused: boolean,
): Promise<void>
{
    // mutate paused status
    try
    {
        graphis.mutate(SEND_PAUSED, {agent, away, paused});
    }

    // mutate failed: log error
    catch (e)
    {
        // get user data
        const {id, name} = fetchUser();

        // log failure
        logger.error('CVJPZ0064E', {
            name,
            user: id,
        });
    }
}


/**
 * I send a template to a conversation.
 *
 * :param company: company id
 * :param conversation: conversation id
 * :param from: agent id
 * :param originalId: original message id
 * :param template: template to be sent
 *
 * :returns: promise with send template result
 */
async function sendTemplate(
    company: number,
    conversation: number,
    from: string,
    originalId: string,
    template: ITemplateInput,
): Promise<ISendTemplateResult>
{
    // initialize response
    let response: ISendTemplateResponse;

    // send template request
    try
    {
        response = await timeout(
            graphis.mutate(SEND_TEMPLATE, {
                company,
                conversation,
                from,
                originalId,
                template,
            }),
            TIMEOUT,
        );
    }

    // send message failed: log and return failure reason
    catch (error)
    {
        logger.error('CVJPZ0020E', {
            conversation,
            user: fetchUser().id,
        });
        return {
            reason: 'requestException',
        };
    }

    // get sent message
    const {sendTemplate} = response.data;

    // send failed with specific error: log and return it
    if (sendTemplate?.__typename === 'Error')
    {
        logger.error('CVJPZ0020E', {
            conversation,
            user: fetchUser().id,
        });

        return {
            reason: sendTemplate.code,
        };
    }

    // send failed with other reason: log and return unknown
    if (sendTemplate === null)
    {
        logger.error('CVJPZ0020E', {
            conversation,
            user: fetchUser().id,
        });

        return {
            reason: REASON_UNKNOWN,
        };
    }

    // deconstruct message without type name
    const {__typename, ...messageData} = sendTemplate;

    // return sended message info
    return {
        message: {
            ...messageData,
            timestamp: messageData.timestamp * 1000,
        },
    };
}


/**
 * I asynchronously sleep.
 *
 * :param duration: sleep duration in milliseconds
 *
 * :returns: promise with nothing
 */
function sleep(duration: number): Promise<void>
{
    return new Promise((resolve, reject) =>
    {
        setTimeout(()=>
        {
            resolve(null);
        }, duration);
    });
}


/**
 * I start conversations aggregate.
 *
 * :returns: nothing
 */
function start (): void
{
    // configure delegate for chat packets
    const chat = new delegates.Chat();
    packetis.delegate('chat', chat.handle.bind(chat));
}


/**
 * I transfer a conversation to another agent.
 *
 * :param id: conversation id
 * :param to: destination agent uid
 * :param uid: user uid
 *
 * :returns: promise with transferred conversation id
 */
async function transfer (
    id: number,
    to: string,
    uid: string,
): Promise<ITransferResult>
{
    // initialize response
    let response: ITransferConversationResponse;

    const variables: ITransferConversationVariables = {
        id,
        to,
        uid,
    };

    // transfer conversation
    try
    {
        response = await graphis.mutate(TRANSFER_CONVERSATION, variables);
    }

    // failed request: return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return {conversation: id, error: REASON_UNKNOWN};
    }

    // get response data props
    const {transferConversation} = response.data;

    // transfer conversation failed: return id null and reason code
    if (transferConversation.__typename === 'Error')
    {
        return {conversation: id, error: transferConversation.code};
    }

    // return transfered conversation id and reason null
    return {conversation: transferConversation.id, error: null};
}


/**
 * I try to free a conversation if a template is not needed.
 *
 * :param account: account id
 * :param contact: contact uid
 *
 * :returns: promise with nothing
 */
async function tryToFree (
    account: number,
    contact: string,
): Promise<void>
{
    // get template requirement from conversation
    const conversation = conversationSelectors.getConversationByAccountAndUid(
        account,
        contact,
    );

    // conversation does not require template: abort
    if (conversation?.templateRequired !== true)
    {
        return;
    }

    // get account uid
    const accountUid = accountSelectors.get(account)?.uid;

    // template not needed: try to free conversation
    if (await needTemplate(accountUid, contact) === false)
    {
        await freeConversation(conversation?.id);
    }
}


/**
 * I upload a payload to the file server.
 *
 * :param file: file to upload
 * :param onProgress: upload progress callback
 * :param onSuccess: upload success callback
 * :param uploadUrl: upload server url
 *
 * :returns: promise with uploaded file id
 *
 * :throws FileUploadError: on file upload error
 */
const upload = async (
    file: File,
    onProgress: IUploadOnProgress,
    onSuccess: IUploadOnSuccess,
    uploadUrl: string,
): Promise<string> =>
{
    // get server url
    const serverUrl = getServerUrl();

    // create observable upload
    const observable = Loadis.upload(`${serverUrl}${uploadUrl}`,
                                     file,
                                     {chunkSize: 1024 * 1024});

    // start upload
    const observer = new Loadis.UploadObserver();
    observable.subscribe(...observer.observe());

    // set progress handler
    observer.onProgress = (progress: Loadis.IUploadProgress): void =>
    {
        // get progress properties
        const {bytesAccepted} = progress;
        const {bytesTotal} = progress;

        // get progress percentage
        const value = Math.round(bytesAccepted / bytesTotal * 100);

        // call progress handler
        onProgress(value);
    };

    // set success handler
    observer.onSuccess = (result: Loadis.UploadResult): void =>
    {
        onSuccess();
    };

    // initialize file id
    let id = undefined;

    // wait until upload is finished
    try
    {
        id = await observer.wait();
    }

    // upload failed: report error
    catch (error)
    {
        throw new FileUploadError(error);
    }

    return id;
};


/**
 * I upload an email to the file server.
 *
 * :param body: email body
 * :param attachments: email attachments
 * :param name: file name
 * :param onProgress: upload progress callback
 * :param onSuccess: upload success callback
 *
 * :returns: promise with uploaded file id
 *
 * :throws FileUploadError: on file upload error
 */
async function uploadEmail (
    body: string,
    attachments: IAttachment[],
    name: string,
    onProgress: IUploadOnProgress,
    onSuccess: IUploadOnSuccess,
): Promise<string>
{
    // FIXME: make upload url configurable
    //
    // set upload url
    const uploadUrl = '/emails/files/';

    // create file to upload
    const email = JSON.stringify({
        attachments,
        body,
    });
    const file = new File([email], name, {type: 'application/json'});

    // upload email to file server
    return upload(file, onProgress, onSuccess, uploadUrl);
}


/**
 * I upload a file to the file server.
 *
 * :param file: file to upload
 * :param name: file name
 * :param type: file mime-type
 * :param onProgress: upload progress callback
 * :param onSuccess: upload success callback
 *
 * :returns: promise with uploaded file id
 *
 * :throws FileUploadError: on file upload error
 */
async function uploadFile (
    file: File,
    onProgress: IUploadOnProgress,
    onSuccess: IUploadOnSuccess,
): Promise<string>
{
    // compress file
    const compressed = await compressFile(file);

    // FIXME: make upload url configurable
    //
    // set upload url
    const uploadUrl = '/uploads/files/';

    // upload file to file server
    return upload(compressed, onProgress, onSuccess, uploadUrl);
}


/**
 * EXPORTS
 */
export {
    analyzeConversations,
    create,
    createNotificationBody,
    fetch,
    fetchAgentsMessagesMetrics,
    fetchApp,
    fetchByIds,
    fetchContactsOngoing,
    fetchConversationFlow,
    fetchConversationsReport,
    fetchEmail,
    fetchMessageByOriginalId,
    fetchMessages,
    fetchPage,
    fetchRealTimeMetrics,
    finish,
    forceFinish,
    freeConversation,
    getConversationAgentName,
    getOnlineAgents,
    getQualityReport,
    load,
    loadByPeriod,
    loadConversationCustomer,
    messageTypesIdToName,
    messageTypesNameToId,
    moveToHistory,
    moveToOngoing,
    moveToTop,
    needTemplate,
    reduceConversation,
    reduceConversationsMetrics,
    reduceConversationReport,
    removeId,
    removePreviousConversations,
    sendAutoAnswer,
    retryMessage,
    sendMessage,
    sendPaused,
    sendTemplate,
    sleep,
    start,
    transfer,
    tryToFree,
    uploadFile,
    uploadEmail,
};
